<template>
  <Tooltip
    class="wrapper"
    :disabled="disabled || isDisable"
    :content="text"
    :max-width="maxWidth"
    v-bind="$attrs"
    :transfer="transfer"
    transfer-class-name="my-tooltip"
  >
    <div ref="Tooltip" class="overhidden" :style="{'font-size':fontSize,color:color}">{{text}}</div>
  </Tooltip>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    text: {
      type: String | Number,
      default: ""
    },
    auto: {
      type: Boolean,
      default: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: String | Number,
      default: "500"
    },
    fontSize: {
      type: String,
      default: ""
    },
    color: {
      type: String,
      default: ""
    },
    transfer: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isDisable: false
    };
  },
  methods: {
    updata() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.isDisable = !(
            this.$refs.Tooltip.scrollWidth > this.$refs.Tooltip.offsetWidth
          );
        }, 100);
      });
    }
  },
  watch: {
    text: {
      handler() {
        this.disabled || this.updata();
      },
      immediate: true
    }
  },
  mounted() {
    if (!this.auto) return;
    window.addEventListener("resize", this.updata);
  },
  destroyed() {
    if (!this.auto) return;
    window.removeEventListener("resize", this.updata);
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
  overflow: hidden;
  max-width: 100%;
  display: flex;
  & ::v-deep .ivu-tooltip-rel {
    width: 100%;
  }
}
.overhidden {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
